var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { t } from '@mp/locale';
import dash from "../assets/images/dash.svg";
import plus from "../assets/images/plus.svg";
export default function ViewMore(_a) {
    var contractAccount = _a.contractAccount, selectedDate = _a.selectedDate, toggleViewAll = _a.toggleViewAll, totalViewable = _a.totalViewable, viewAll = _a.viewAll;
    var viewMoreLabel = function () {
        var slots = selectedDate === null || selectedDate === void 0 ? void 0 : selectedDate.availableSlots;
        if (contractAccount && slots) {
            var hasInPolicy = slots.find(function (s) { return s.inPolicy; });
            if (!hasInPolicy) {
                return "";
            }
            if (viewAll) {
                return (_jsxs(_Fragment, { children: [t("CAPTURE_SERVICES.SCHEDULER.hideOffHours"), " ", _jsx("img", { src: dash })] }));
            }
            else {
                return (_jsxs(_Fragment, { children: [t("CAPTURE_SERVICES.SCHEDULER.showOffHours"), " ", _jsx("img", { src: plus })] }));
            }
        }
        if (slots && slots.length <= totalViewable) {
            return "";
        }
        if (viewAll) {
            return (_jsxs(_Fragment, { children: [t("CAPTURE_SERVICES.SCHEDULER.less"), " ", _jsx("img", { src: dash })] }));
        }
        else {
            return (_jsxs(_Fragment, { children: [t("CAPTURE_SERVICES.SCHEDULER.more"), " ", _jsx("img", { src: plus })] }));
        }
    };
    return (_jsx("button", __assign({ id: "mp-scheduler-more", type: "button", onClick: toggleViewAll }, { children: _jsx("strong", { children: viewMoreLabel() }) })));
}
